import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";

import { useLanguage } from "../../../context/LanguageProvider";
import { resolvePublicImageUrl } from "../../../shared/utils/apiConfig";
import { toFarsiNumber } from "../../../shared/utils/commonUtils";
import ResponsiveImage from "../../../shared/components/elements/ResponsiveImage";

import type { BlogSummary } from "../types";
import { formatRelativeTime } from "../utils/date";

interface BlogCardProps {
    blog: BlogSummary;
}

// The page wraps this card in a <Link>, so it contains no link itself
const BlogCard = ({ blog }: BlogCardProps) => {
    const { lang, t } = useLanguage();

    const readTime = blog.read_time ?? 0;

    return (
        <div className="w-full transition hover:-translate-y-3">
            <div className="relative">
                <ResponsiveImage
                    src={resolvePublicImageUrl(blog.image)}
                    alt={blog.title}
                    className="w-full rounded-md h-64 object-cover"
                />

                {/* Bottom-left read time */}
                <div className="absolute bottom-2 left-2 bg-white/90 text-gray-800 text-xs px-3 py-1 rounded-full flex items-center gap-1 shadow">
                    <FontAwesomeIcon icon={faClock} />
                    <span>
                        {lang === "fa" ? toFarsiNumber(readTime) : readTime} {t.blog.minutes}
                    </span>
                </div>
            </div>

            <div className="py-8 px-6">
                <h2 className="text-xl line-clamp-2 leading-relaxed font-bold">{blog.title}</h2>

                {blog.category && <span className="block text-lg mt-5">{blog.category}</span>}

                <p className="text-md mt-5">{formatRelativeTime(blog.created_at, lang)}</p>
            </div>
        </div>
    );
};

export default BlogCard;